import { useQuery } from "react-query";
import { getForms, getOrganizationForms } from "../api";
import FormsWithEntryUsage from "models/forms-with-entry-usage";

export const useGetFormsWithEntryUsage = ({
	organizationId,
	eventId,
	options = {}
}) => {
	return useQuery(
		["forms-entry-usage", organizationId, eventId],
		async () => {
			const queryParams = {
				type: "ticket",
				group_by: "entry_usage"
			};

			const response = eventId
				? await getForms({ organizationId, eventId, queryParams })
				: await getOrganizationForms({
						organizationId,
						params: queryParams
				  });

			const data = response.response || response;
			return FormsWithEntryUsage.buildFromJSON(data);
		},
		{
			...options,
			enabled: (options?.enabled ?? true) && Boolean(organizationId)
		}
	);
};
